<template>
    <div class="ccris-summary">
        <b-card no-body>
            <!-- 🔹 Credit Marks at the top -->
            <div v-if="ctosScore" class="p-3 d-flex align-items-center">
              <span class="font-weight-bold text-dark mr-2" style="min-width: 100px; font-size: 1.25rem;">Credit Marks:</span>
              <span
                class="px-4 py-2 text-dark font-weight-bold text-center"
                style="min-width: 100px; font-size: 1.25rem;"
              >
                {{ ctosScore }}
              </span>
            </div>
            <div v-else class="p-3 d-flex align-items-center">
              <span class="font-weight-bold text-dark mr-2" style="min-width: 100px; font-size: 1.25rem;">Credit Marks:</span>
              <span
                class="px-4 py-2 text-dark font-weight-bold text-center"
                style="min-width: 100px; font-size: 1.25rem;"
              >
                {{ '0' }}
              </span>
            </div>
            <b-card-header class="py-2 px-3">
                <h3 class="mb-0">CCRIS Summary</h3>
            </b-card-header>
            <div v-if="tableData.length > 0" class="card-table rounded-bottom">
                <el-table
                :data="tableData"
                show-summary
                :summary-method="getSummaries"
                style="width: 100%">
                    <el-table-column
                        prop="ccris_sum_loan_label"
                        label="Summary Facility Type"
                        min-width="200">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.ccris_sum_loan_label }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ccris_sum_detected"
                        label="Detected"
                        min-width="100"
                        class-name="text-center">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.ccris_sum_detected }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ccris_sum_current_outstanding"
                        label="Total Outstanding Balance (RM)"
                        min-width="160">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.ccris_sum_current_outstanding | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ccris_sum_current_installment"
                        label="Total Commitment (RM)"
                        min-width="170">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.ccris_sum_current_installment | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ccris_sum_new_installment"
                        label="Total New Commitment (RM)"
                        min-width="170">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.ccris_sum_new_installment | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No CCRIS Summary recorded</p>
            </div>
        </b-card>
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui'
    
    export default {
        name: 'summary-ccris',
        props: ['summary-ccris', 'ctosScore'],
        components: {
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.summaryCcris
            }
        },
        methods: {
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = 'Total';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        const sum = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                            return prev + curr;
                            } else {
                            return prev;
                            }
                        }, 0);
                        sums[index] = index === 1 ? `${sum}` : `RM ${sum.toLocaleString(undefined, {minimumFractionDigits: 2})}`;  
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                return sums;
            }
        }
    }
</script>